function SignIn() {
  return (
    <div className="Sign-in">
      <header className="Sign-in-header">Welcome to Sign in</header>
    </div>
  );
}

export default SignIn;
